import { render, staticRenderFns } from "./EventsContestantsResultsListTable.vue?vue&type=template&id=31d1da45&"
import script from "./EventsContestantsResultsListTable.vue?vue&type=script&lang=ts&"
export * from "./EventsContestantsResultsListTable.vue?vue&type=script&lang=ts&"
import style0 from "./EventsContestantsResultsListTable.vue?vue&type=style&index=0&id=31d1da45&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EventsContestantsResultsListTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports